import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

const useSocials = () => {
  const [socials, setSocials] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  const getSocialName = (id) => {
    return socials?.find((social) => social.id === id)?.name ?? "";
  };

  useEffect(() => {
    async function fetchAll() {
      try {
        const tiers = await dataProvider.getList("socials", {});
        setSocials(tiers.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { socials, loading, error, getSocialName };
};

export default useSocials;
